import { render, staticRenderFns } from "./Anejo14StudentBySpecialist.vue?vue&type=template&id=33f3088c&"
import script from "./Anejo14StudentBySpecialist.vue?vue&type=script&lang=js&"
export * from "./Anejo14StudentBySpecialist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports